// extracted by mini-css-extract-plugin
module.exports = {"root":"order-item_root__36PGP","row":"order-item_row__2hQDZ","label":"order-item_label__3xiWy","value":"order-item_value__BFLtc"};